import React, { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import Layout from "../components/Layout";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";

const API = process.env.REACT_APP_BACKEND_URL + "/api";
const headers = () => { const t = localStorage.getItem("cauldron_token"); return t ? { Authorization: `Bearer ${t}` } : {}; };

export default function ProCoupons() {
  const [coupons, setCoupons] = useState([]);
  const [form, setForm] = useState({ code: "", percentOff: 15 });
  const [gated, setGated] = useState(false);

  const load = async () => {
    try {
      const r = await axios.get(`${API}/coupons`, { headers: headers() });
      setCoupons(r.data.coupons || []);
    } catch (e) {
      if (e.response?.status === 403) setGated(true);
    }
  };
  useEffect(() => { load(); }, []);

  const create = async () => {
    try {
      await axios.post(`${API}/coupons`, form, { headers: headers() });
      toast.success("Coupon created");
      setForm({ code: "", percentOff: 15 });
      load();
    } catch (e) { toast.error(e.response?.data?.detail || "Failed"); }
  };

  const remove = async (code) => {
    try {
      await axios.delete(`${API}/coupons/${code}`, { headers: headers() });
      load();
    } catch { toast.error("Failed"); }
  };

  if (gated) {
    return <Layout><div className="max-w-2xl mx-auto p-8 text-center text-amber-200/70">
      <h1 className="text-2xl font-serif text-amber-100 mb-3">Coupons are a Pro feature</h1>
      <a href="/pricing" className="text-amber-400 underline">Upgrade to Pro →</a>
    </div></Layout>;
  }

  return (
    <Layout>
      <div className="max-w-4xl mx-auto p-6" data-testid="pro-coupons">
        <h1 className="text-3xl font-serif text-amber-100 mb-6">Coupons</h1>
        <div className="rounded-lg border border-neutral-800 bg-neutral-900/50 p-4 mb-6">
          <div className="text-xs text-amber-200/50 uppercase mb-3">Create a code</div>
          <div className="flex gap-2 items-center">
            <Input placeholder="WELCOME20" value={form.code} onChange={e => setForm({...form, code: e.target.value.toUpperCase()})} className="uppercase" data-testid="coupon-code" />
            <Input type="number" min="1" max="90" value={form.percentOff} onChange={e => setForm({...form, percentOff: parseInt(e.target.value) || 15})} className="w-24" data-testid="coupon-percent" />
            <span className="text-amber-200/60 text-sm">%</span>
            <Button onClick={create} disabled={!form.code || form.code.length < 3} data-testid="save-coupon">Create</Button>
          </div>
        </div>
        {coupons.length === 0 ? (
          <div className="text-amber-200/60 py-12 text-center text-sm">No coupons yet.</div>
        ) : (
          <ul className="space-y-2" data-testid="coupon-list">
            {coupons.map(c => (
              <li key={c.id} className="flex justify-between items-center p-3 rounded-lg border border-neutral-800 bg-neutral-900/40" data-testid={`coupon-${c.code}`}>
                <div>
                  <div className="font-mono text-amber-100">{c.code}</div>
                  <div className="text-xs text-amber-200/50">
                    {c.percentOff}% off · {c.redemptions} redemption{c.redemptions === 1 ? "" : "s"}
                    {c.maxRedemptions ? ` / ${c.maxRedemptions}` : ""}
                  </div>
                </div>
                <button onClick={() => remove(c.code)} className="text-red-400 text-xs hover:text-red-300" data-testid={`remove-coupon-${c.code}`}>Delete</button>
              </li>
            ))}
          </ul>
        )}
      </div>
    </Layout>
  );
}
